export default __webpack_public_path__ + "static/media/menu1_hl.33bbd5a3.png";